const translations = {};

translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "密碼不符。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "請輸入 6 個字元或以上的密碼。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "應用程式有新版本可用。\n需要更新才能使用最新功能。\n更新將很快完成。";
translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "正在將應用程式更新至最新版本。";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "輸入訊息...";
translations["MSG_ASSISTANT_SEND"] = "發送";
translations["MSG_BACK_BTN"] = "返回";
translations["MSG_BACK_BTN_BY_PARENT"] = "返回";
translations["MSG_BIRTHDAY_DAY_SUFFIX_BY_PARENT"] = "日";
translations["MSG_BIRTHDAY_MONTH_SUFFIX_BY_PARENT"] = "月";
translations["MSG_BIRTHDAY_YEAR_SUFFIX_BY_PARENT"] = "年";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}字元以內。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT_BY_PARENT"] = "%{limit}個字元以內";
translations["MSG_BODY_TYPE_CHUBBY_BY_PARENT"] = "偏胖";
translations["MSG_BODY_TYPE_MEDIUM_BY_PARENT"] = "中等";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY_BY_PARENT"] = "微胖";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN_BY_PARENT"] = "偏瘦";
translations["MSG_BODY_TYPE_THIN_BY_PARENT"] = "瘦";
translations["MSG_BODY_TYPE_TITLE_BY_PARENT"] = "體型";
translations["MSG_BOYS_COUNT"] = "男孩";
translations["MSG_BTN_CLOSE"] = "關閉";
translations["MSG_BTN_LATER"] = "稍後";
translations["MSG_CANCEL_BTN"] = "取消";
translations["MSG_CANCEL_BTN_BY_PARENT"] = "取消";
translations["MSG_CITY_TITLE"] = "城市";
translations["MSG_COLOR_BLUE_BY_PARENT"] = "藍色";
translations["MSG_COLOR_GREEN_BY_PARENT"] = "綠色";
translations["MSG_COLOR_OTHER_PLACEHOLDER_BY_PARENT"] = "輸入自我介紹顏色";
translations["MSG_COLOR_RED_BY_PARENT"] = "紅色";
translations["MSG_COLOR_SELECT_SHADE"] = "選擇你喜歡的色調";
translations["MSG_COLOR_WHITE_BY_PARENT"] = "白色";
translations["MSG_COLOR_YELLOW_BY_PARENT"] = "黃色";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_SOLO"] = "個人事業主";
translations["MSG_COMPANY_SIZE_TITLE"] = "公司規模";
translations["MSG_CONFIRM_BTN_BY_PARENT"] = "確定";
translations["MSG_COURSE_ALGORITHM"] = "學習演算法！";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "演算法進階";
translations["MSG_COURSE_GROUP_WORK"] = "小組合作";
translations["MSG_COURSE_PROGRAM"] = "程式設計入門";
translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "選擇課程";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "選擇關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "選擇等級";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "等級";
translations["MSG_ERROR_NETWORK"] = "網路錯誤";
translations["MSG_FACE_SHAPE_OBLONG_BY_PARENT"] = "長臉";
translations["MSG_FACE_SHAPE_OVAL_BY_PARENT"] = "鵝蛋臉";
translations["MSG_FACE_SHAPE_ROUND_BY_PARENT"] = "圓臉";
translations["MSG_FACE_SHAPE_SQUARE_BY_PARENT"] = "方臉";
translations["MSG_FACE_SHAPE_TITLE_BY_PARENT"] = "臉型";
translations["MSG_FACE_SHAPE_TRIANGLE_BY_PARENT"] = "三角臉";
translations["MSG_GENDER_FEMALE_BY_PARENT"] = "女孩";
translations["MSG_GENDER_MALE_BY_PARENT"] = "男孩";
translations["MSG_GENDER_NONE"] = "無";
translations["MSG_GENERATE_BTN_BY_PARENT"] = "生成";
translations["MSG_GIRLS_COUNT"] = "女孩";
translations["MSG_GLASSES_NONE_BY_PARENT"] = "無";
translations["MSG_GLASSES_TITLE_BY_PARENT"] = "眼鏡";
translations["MSG_GLASSES_YES_BY_PARENT"] = "有";
translations["MSG_HAIRSTYLE_LONG_BY_PARENT"] = "長";
translations["MSG_HAIRSTYLE_MEDIUM_BY_PARENT"] = "中等";
translations["MSG_HAIRSTYLE_SHORT_BY_PARENT"] = "短";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG_BY_PARENT"] = "略長";
translations["MSG_HAIRSTYLE_TITLE_BY_PARENT"] = "髮型";
translations["MSG_HAIRSTYLE_VERY_SHORT_BY_PARENT"] = "很短";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "家庭成員";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "爸爸";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "爺爺";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "奶奶";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "媽媽";
translations["MSG_ICON_CATEGORY_ALL"] = "全部";
translations["MSG_ICON_CATEGORY_BOY_BY_PARENT"] = "男孩";
translations["MSG_ICON_CATEGORY_GIRL_BY_PARENT"] = "女孩";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "當前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "已選擇";
translations["MSG_ICON_CONFIRM_BTN_BY_PARENT"] = "就這個";
translations["MSG_ICON_CONFIRM_PROMPT_BY_PARENT"] = "這個頭像可以嗎？";
translations["MSG_ICON_GENERATING_BY_PARENT"] = "正在生成頭像...";
translations["MSG_ICON_REGENERATE_BTN_BY_PARENT"] = "重新生成";
translations["MSG_ICON_CREATE_BTN"] = "建立";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "如果想添加什麼";
translations["MSG_ICON_SELECT_PROFILE_AI_BY_PARENT"] = "AI自動從\n個人資料\n生成";
translations["MSG_ICON_SELECT_SYSTEM_BY_PARENT"] = "預設\n頭像";
translations["MSG_ICON_SELECT_TITLE_BY_PARENT"] = "為孩子選擇頭像";
translations["MSG_ICON_SELECT_UPLOAD_BY_PARENT"] = "上傳\n圖片";
translations["MSG_INDUSTRY_TITLE"] = "行業";
translations["MSG_INDUSTRY_IT"] = "IT・通訊";
translations["MSG_INDUSTRY_MANUFACTURING"] = "製造業";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保險";
translations["MSG_INDUSTRY_RETAIL"] = "零售・批發";
translations["MSG_INDUSTRY_HEALTHCARE"] = "醫療・福利";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "政府・公務員";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "房地產";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建築";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "運輸・物流";
translations["MSG_INDUSTRY_MEDIA"] = "媒體・廣告";
translations["MSG_INDUSTRY_SERVICE"] = "服務業";
translations["MSG_INDUSTRY_OTHER"] = "其他";
translations["MSG_JOB_TITLE_LABEL"] = "職位";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "經營者・高管";
translations["MSG_JOB_TITLE_MANAGER"] = "管理職";
translations["MSG_JOB_TITLE_GENERAL"] = "一般職員";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "專業職";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "無職位（家庭主婦／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "無職位（學生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "無職位（無業）";
translations["MSG_LOADING"] = "載入中...";
translations["MSG_NEXT_BTN_BY_PARENT"] = "下一步";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "通知";
translations["MSG_OCCUPATION_TITLE"] = "職業";
translations["MSG_OCCUPATION_EXECUTIVE"] = "經營・高管";
translations["MSG_OCCUPATION_MANAGER"] = "管理職";
translations["MSG_OCCUPATION_ENGINEER"] = "工程師・技術";
translations["MSG_OCCUPATION_SALES"] = "銷售";
translations["MSG_OCCUPATION_MARKETING"] = "市場行銷";
translations["MSG_OCCUPATION_HR"] = "人事・行政";
translations["MSG_OCCUPATION_ACCOUNTING"] = "財務・會計";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究・開發";
translations["MSG_OCCUPATION_TEACHER"] = "教師・講師";
translations["MSG_OCCUPATION_DOCTOR"] = "醫生";
translations["MSG_OCCUPATION_NURSE"] = "護士";
translations["MSG_OCCUPATION_LAWYER"] = "律師・法務";
translations["MSG_OCCUPATION_DESIGNER"] = "設計師";
translations["MSG_OCCUPATION_FREELANCE"] = "自由職業";
translations["MSG_OCCUPATION_HOMEMAKER"] = "全職主婦・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "學生";
translations["MSG_OCCUPATION_OTHER"] = "其他";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "查看計劃";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "發送圖片需要「特別計劃」\n升級到特別計劃後可以發送圖片";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "關於圖片功能";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "選擇";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "返回";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "確認";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "創建";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "下一步";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "重新創建";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "選擇頭像方式";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "預設\n頭像";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "請選擇頭像";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "這個頭像可以嗎？";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "正在創建頭像...";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "AI自動從\n個人資料\n生成";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "上傳\n圖片";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500-1000萬日圓";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000萬日圓以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "不願透露";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "年收入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500萬日圓以下";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "選擇圖片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "上傳圖片";
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "帳號操作";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "帳號建立日期";
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "帳號資訊";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "帳號狀態";
translations["MSG_PARENT_PAGE_ACTIVE"] = "活躍";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "和學伴君聊天了";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "樂學拼圖 支援";
translations["MSG_PARENT_PAGE_SUPPORT_WELCOME"] =
  "這裡是『樂學拼圖』支援窗口。\n如有任何疑問、故障或需求，請在此留言給我們。";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "感謝您的詢問！\n請在下方的輸入欄位中填寫您的問題。";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "給應用評了★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "通過了%{course}的階段%{stage} 等級%{level}！";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活動";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "收到了點讚";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "發送了回饋";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "更換了頭像";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "發送了問題反饋";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "登入了";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "創建了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "給「%{name}」點了讚";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "發佈了「%{name}」";
translations["MSG_PARENT_PAGE_ADD"] = "新增";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "目前方案最多可新增{{limit}}位使用者。\n升級方案後可新增更多使用者。";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "無法添加用戶";
translations["MSG_PARENT_PAGE_AGE"] = "年齡";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "與學伴君聊天";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "回答問題和諮詢";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "培養孩子好奇心的對話體驗";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "可以討論想法";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "與學伴君聊天";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "8次/日";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI聊天記錄";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "暫無聊天記錄";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}則訊息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "暫無訊息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "無標題";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "無限制";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "無限制";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "與AI角色愉快聊天！";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AI創作素材";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT"] = "搖動告知";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_DESCRIPTION"] =
  "已附上目前畫面。請填寫問題內容後送出。";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_PLACEHOLDER"] = "請填寫在哪個畫面、發生了什麼問題。";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_ATTACH_OFF"] = "未附加圖片";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_ATTACH_PICK"] = "選擇圖片";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_BTN"] = "送給客服";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_SENDING"] = "傳送中…";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_SENT"] = "已送給客服。";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_SEND_FAILED"] = "傳送失敗。請稍後再試。";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION"] =
  "關閉後，搖動裝置將不會顯示回報畫面。";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "創建原創圖標";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "用於「自由創作」";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "也可傳送到聊天";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI素材圖像生成";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "無限制（同時生成3張）";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "10次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "將想像變成圖像！";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] = "使用家長應用程式查看孩子的學習進度並管理設定。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本資訊";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "計費週期";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "修改生日";
translations["MSG_PARENT_PAGE_CHANGE"] = "變更";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "變更密碼";
translations["MSG_PARENT_PAGE_STORAGE_FEATURE"] = "資料儲存容量";
translations["MSG_PARENT_PAGE_STORAGE_FREE_LIMIT"] = "1GB";
translations["MSG_PARENT_PAGE_STORAGE_STANDARD_LIMIT"] = "5GB";
translations["MSG_PARENT_PAGE_STORAGE_PREMIUM_LIMIT"] = "50GB";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI圖片";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "相簿";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "還沒有素材";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "建立日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "尺寸";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "未命名";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "應用列表";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "還沒有應用";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "次複製";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "建立日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "個讚";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "已發佈";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公開";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "次瀏覽";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "查看更多";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "畫板";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "請輸入新名字";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "修改名字";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "問題回報";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使用方法";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自我介紹";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "功能請求";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "複製許可";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "已授權的內容（卡帶）";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "輸入認證碼";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "如果您持有「樂學拼圖」認證碼（企業合作碼），請在下方輸入指定的代碼。";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企業合作代碼";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "確定";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] = "如果您有企業合作代碼，請在這裡輸入。";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "沒有已授權的追加內容（卡帶）。";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "查看課程答案";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "課程完成";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "註冊日期";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "建立的作品";
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "目前方案";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危險操作";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "刪除";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "刪除此使用者";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}} 被刪除後，此使用者的所有資料（進度、作品等）將會消失。\n此操作無法復原。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "至少需要 1 位使用者。\n刪除前請先新增另一位使用者。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "無法刪除用戶";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "刪除用戶？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "所有學習資料和作品將被刪除。此操作無法撤銷。";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "顯示語言";
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "下載家長應用程式";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "編輯擅長科目";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "編輯體型";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "編輯臉型";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "編輯喜歡的顏色";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "編輯眼鏡";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "編輯髮型";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "編輯自我介紹";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] = "您正在使用企業合約。詳情請聯繫管理員。";
translations["MSG_PARENT_PAGE_EMAIL"] = "電子郵件";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "郵件驗證";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "輸入企業認證代碼";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "反饋詳情";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "反饋歷史";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "還沒有反饋";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未回覆";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "給應用程式評了★%{rating}";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "已回覆";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "諮詢";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "反饋";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "應用程式評價";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "此玩家已停用，無法切換登入。請先啟用玩家。";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "無法切換";
translations["MSG_PARENT_PAGE_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "修改性別";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google帳號";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "平假名";
translations["MSG_PARENT_PAGE_ICON"] = "頭像";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非活躍";
translations["MSG_PARENT_PAGE_KANJI"] = "漢字";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "選擇顯示語言";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "更改語言";
translations["MSG_PARENT_PAGE_LANGUAGE_EN"] = "英語";
translations["MSG_PARENT_PAGE_LANGUAGE_JA"] = "日語";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_CN"] = "簡體中文";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_TW"] = "繁體中文";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "學習支援";
translations["MSG_PARENT_PAGE_LINK"] = "綁定";
translations["MSG_PARENT_PAGE_LOGOUT"] = "登出";
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "輸入訊息...";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "載入更多";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "暫無訊息";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "沒有聊天室";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_NICKNAME"] = "暱稱";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "請輸入新的暱稱";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "變更暱稱";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "請嘗試自我介紹名稱";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24小時內暫無活動";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "方案比較";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "方案資訊";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_ACCOUNT"] = "帳戶整體";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_PLAYER"] = "每位玩家";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "可遊玩";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本資料";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自我介紹備註";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "個人資料";
translations["MSG_PARENT_PAGE_USAGE_SECTION_TITLE"] = "使用狀況";
translations["MSG_PARENT_PAGE_USAGE_PLAYERS"] = "玩家數";
translations["MSG_PARENT_PAGE_USAGE_STORAGE"] = "資料儲存容量";
translations["MSG_PARENT_PAGE_USAGE_CHAT_HISTORY"] = "聊天紀錄";
translations["MSG_PARENT_PAGE_USAGE_ITEMS"] = "筆";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "個人資料更新失敗";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "個人資料更新成功";
translations["MSG_PARENT_PAGE_PROJECTS"] = "個作品";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = "「自由創作」作品數";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品公開";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "已發布作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "獲得的讚";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近活動";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24小時的活動";
translations["MSG_PARENT_PAGE_SETTINGS"] = "設定";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "帳號綁定";
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "購買方式";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "已暫停";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "切換到「%{name}」。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "切換玩家？";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切換";
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "家長帳號";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "頭像";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本資料";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "玩家管理";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "個性";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "訊息";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "通知";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "其他";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "訂閱管理";
translations["MSG_PARENT_PAGE_TODAY"] = "今天";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "無限制";
translations["MSG_PARENT_PAGE_UNLINK"] = "解除綁定";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "購買方案";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "玩家數";
translations["MSG_PARENT_PAGE_VERIFIED"] = "已驗證";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "查看教學";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "歲";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨天";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "頭像";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家庭";
translations["MSG_PARENT_PROFILE_REGION"] = "地區";
translations["MSG_PARENT_PROFILE_WORK"] = "工作";
translations["MSG_PLAN_BUILDER_PARENT"] = "創作者";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "免費方案";
translations["MSG_PLAN_FREE_PARENT"] = "免費";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "高級方案";
translations["MSG_PLAN_PREMIUM_PARENT"] = "高級";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本方案";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PREFECTURE_TITLE"] = "省份";
translations["MSG_PROFILE_AI_BEST_SUBJECTS_BY_PARENT"] = "擅長科目";
translations["MSG_PROFILE_AI_BODY_TYPE_BY_PARENT"] = "體型";
translations["MSG_PROFILE_AI_FACE_SHAPE_BY_PARENT"] = "臉型";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "喜歡的顏色";
translations["MSG_PROFILE_AI_GLASSES"] = "眼鏡";
translations["MSG_PROFILE_AI_HAIRSTYLE_BY_PARENT"] = "髮型";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER_BY_PARENT"] = "請介紹一下您的孩子";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY_BY_PARENT"] = "生日";
translations["MSG_PROFILE_SUBSTEP_GENDER_BY_PARENT"] = "性別";
translations["MSG_PROFILE_SUBSTEP_ICON_BY_PARENT"] = "頭像";
translations["MSG_PROFILE_STEP_GENDER_DESC"] = "請選擇您的性別。";
translations["MSG_PROFILE_STEP_BIRTHDAY_DESC"] = "請選擇您的生日。";
translations["MSG_PROFILE_STEP_APPEARANCE_DESC"] = "請從選項中選擇最接近的。";
translations["MSG_PROFILE_STEP_WORK_DESC"] = "請選擇您的工作資訊。";
translations["MSG_PROFILE_STEP_REGION_DESC"] = "請選擇您所在的都道府縣和地區。";
translations["MSG_PROFILE_STEP_FAMILY_DESC"] = "請選擇同住的家庭成員（可多選）";
translations["MSG_QR_LOGIN_ISSUE_BTN"] = "掃描 QR 碼";
translations["MSG_QR_LOGIN_ISSUE_CODE_LABEL"] = "登入代碼";
translations["MSG_QR_LOGIN_ISSUE_DESC"] =
  "在想要登入的裝置上，開啟登入頁面的「用QR碼登入」，掃描此QR碼或輸入代碼。";
translations["MSG_QR_LOGIN_ISSUE_ERROR"] = "代碼產生失敗。請稍後再試。";
translations["MSG_QR_LOGIN_ISSUE_EXPIRED"] = "此代碼已過期。";
translations["MSG_QR_LOGIN_ISSUE_EXPIRES_IN"] = "有效期限：剩餘 %{time}";
translations["MSG_QR_LOGIN_ISSUE_REGENERATE"] = "產生新代碼";
translations["MSG_QR_LOGIN_ISSUE_TITLE"] = "用QR碼登入";
translations["MSG_QR_LOGIN_ISSUE_WARNING"] = "請勿將此代碼告訴他人。知道此代碼的人可以登入此帳戶。";
translations["MSG_QR_LOGIN_SCAN_BTN"] = "用QR碼登入";
translations["MSG_QR_LOGIN_SELECT_HINT"] =
  "在本裝置顯示 QR 碼，用已登入的「樂學拼圖」或家長應用程式掃描並允許，即可登入。";
translations["MSG_AUTH_OR_DIVIDER"] = "或";
translations["MSG_QR_LOGIN_SCAN_CAMERA_ERROR"] = "無法啟動相機。請輸入代碼。";
translations["MSG_QR_LOGIN_SCAN_DESC"] = "請掃描已登入裝置上顯示的QR碼。";
translations["MSG_QR_LOGIN_SCAN_INVALID"] = "代碼無效或已過期。\n請重試。";
translations["MSG_QR_LOGIN_SCAN_MANUAL_DESC"] = "無法使用相機時，請輸入顯示的代碼。";
translations["MSG_QR_LOGIN_SCAN_MANUAL_LABEL"] = "輸入代碼";
translations["MSG_QR_LOGIN_SWITCH_TO_SCAN"] = "掃描 QR 碼";
translations["MSG_QR_LOGIN_SCAN_SUBMIT"] = "登入";
translations["MSG_QR_LOGIN_SCAN_TITLE"] = "用QR碼登入";
translations["MSG_QR_LOGIN_DISPLAY_DESC"] =
  "請用已登入的「樂學拼圖」或家長應用程式掃描此 QR 碼，並允許登入。";
translations["MSG_QR_LOGIN_WAITING"] = "正在等待允許…";
translations["MSG_QR_LOGIN_APPROVE_TITLE"] = "允許其他裝置登入";
translations["MSG_QR_LOGIN_APPROVE_DESC"] = "請掃描想要登入的裝置上顯示的 QR 碼，或輸入其代碼。";
translations["MSG_QR_LOGIN_APPROVE_CONFIRM"] = "要登入嗎？";
translations["MSG_QR_LOGIN_APPROVE_CONFIRM_DESC"] =
  "如果沒有印象，\n請關閉此畫面。\n要使用%{app}，\n請點按［登入］。";
translations["MSG_QR_LOGIN_APP_NAME_KIDS"] = "「樂學拼圖」";
translations["MSG_QR_LOGIN_APP_NAME_PARENTS"] = "家長應用";
translations["MSG_QR_LOGIN_APPROVE_SUCCESS"] = "已允許登入。";
translations["MSG_REAUTH_BACK"] = "返回";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] = "將向以下郵箱發送密碼重置郵件";
translations["MSG_REAUTH_SSO_MESSAGE"] = "請再次登入以繼續";
translations["MSG_REAUTH_TITLE"] = "身份驗證";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "查看方案";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "難以使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "不知道\n如何使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "太難";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "太簡單";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "關卡\n太少";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "關卡\n太多";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "無法\n順利創作";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "難以\n使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "沒有抱怨";
translations["MSG_SELECT_PLACEHOLDER_BY_PARENT"] = "請選擇";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "前往 '樂學拼圖' 網站";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "聯絡我們";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "隱私權政策";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "服務條款";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "無法暫停目前登入的使用者。\n請先切換到其他使用者，然後再暫停此使用者。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "無法變更";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "最多只能有 4 位有效使用者。\n若要啟用此使用者，請先停用（或刪除）另一位不需要的使用者。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "無法啟用";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "至少需要一位使用者。\n無法再減少使用者數量。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "無法變更";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "暫停此使用者的遊玩。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "暫停遊玩";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "恢復此使用者的遊玩。";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "恢復遊玩";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "驗證碼";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "社群帳戶已連結到另一個帳戶。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "無法連結";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "刪除帳戶";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "登出帳戶後，您將無法使用目前的使用者遊玩。\n使用者資訊已儲存在帳戶中，如果您想再次使用相同的使用者遊玩，請使用此帳戶重新登入。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "登出";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] = "請告訴我們刪除帳戶的原因。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "刪除帳戶將移除所有資料，包括帳戶和使用者。\n帳戶刪除後無法復原。請小心操作。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "您確定要刪除帳戶嗎？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "從 '樂學拼圖' 刪除您的帳戶將刪除以下所有資料：\n・註冊的個人資料和帳戶資訊。\n・所有已註冊的使用者資訊。\n・使用者在「自由創作」中建立的應用程式。\n・使用者在「透過課程學習」中完成的所有成績和成就。\n・使用者進行的「對話紀錄」等。\n* 【重要】刪除已登入的帳戶將刪除與此帳戶相關的所有資料，請務必小心。\n* 【重要】此操作在任何情況下都無法復原。刪除帳戶時請務必小心。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】請注意";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企業合作認證";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "檢視課程答案";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "目前密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "確認密碼";
translations["MSG_SIGN_EMAIL_SENT"] = "郵件已發送";
translations["MSG_SIGN_GOOGLE_AMAZON_NOTICE"] =
  "※在 Amazon 裝置的兒童檔案中，Google 登入可能會失敗。";
translations["MSG_SIGN_IN_BTN"] = "登入";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "輸入的密碼不正確。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "密碼變更成功。";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "電子郵件地址或密碼不正確。";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "登入失敗";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "忘記密碼？";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "登入成功。";
translations["MSG_SIGN_IN_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "使用 Google 繼續";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] = "密碼重置郵件發送失敗。請重試。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "發送重置郵件";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] = "將向以下電子郵件地址發送密碼重置郵件。";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "已發送密碼重置郵件。";
translations["MSG_CLOSE_BTN_BY_PARENT"] = "關閉";
translations["MSG_SIGN_USER_PASSWORD"] = "密碼";
translations["MSG_SUBJECT_ART_BY_PARENT"] = "美術";
translations["MSG_SUBJECT_ENGLISH_BY_PARENT"] = "英語";
translations["MSG_SUBJECT_ETHICS_BY_PARENT"] = "道德";
translations["MSG_SUBJECT_HOME_EC_BY_PARENT"] = "家政";
translations["MSG_SUBJECT_JAPANESE_BY_PARENT"] = "日語";
translations["MSG_SUBJECT_MATH_BY_PARENT"] = "數學";
translations["MSG_SUBJECT_MUSIC_BY_PARENT"] = "音樂";
translations["MSG_SUBJECT_PE_BY_PARENT"] = "體育";
translations["MSG_SUBJECT_PROGRAMMING_BY_PARENT"] = "程式設計";
translations["MSG_SUBJECT_SCIENCE_BY_PARENT"] = "科學";
translations["MSG_SUBJECT_SOCIAL_BY_PARENT"] = "社會";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "立省 2 個月！";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年付";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年訂閱";
translations["MSG_SUBSCRIPTION_DISCOUNT_BADGE"] = "家計支援";
translations["MSG_SUBSCRIPTION_MANAGE"] = "管理訂閱";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] = "請在App Store管理您購買的訂閱";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] = "請在Google Play管理您購買的訂閱";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月付";
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月訂閱";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] = "此訂閱是在其他平台購買的";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "在其他平台購買";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "無法開啟入口";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "購買";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "購買失敗，請重試。";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "購買成功！";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "訂閱管理";
translations["MSG_TOAST_DELETED_SUCCESS"] = "刪除成功";
translations["MSG_TOAST_EDIT_SUCCESS"] = "變更成功";
translations["MSG_TOAST_ERROR"] = "發生錯誤";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "檔案太大";
translations["MSG_TOAST_SEND_FAILED"] = "傳送失敗";
translations["MSG_UPLOAD_ICON_HINT_BY_PARENT"] = "JPG、PNG格式，最大5MB";
translations["MSG_UPLOAD_ICON_SELECT_BY_PARENT"] = "選擇圖片";
translations["MSG_UPLOAD_ICON_TITLE_BY_PARENT"] = "上傳圖片";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "請輸入10個字元以內的姓名";
translations["MSG_USER_NAME_REQUIRED"] = "請輸入姓名";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_TITLE"] = "沒有玩家";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_MESSAGE"] = "添加孩子開始學習";
translations["MSG_PARENT_PAGE_PLAYER_ADD_BTN"] = "添加玩家";
translations["MSG_PARENT_PAGE_LAUNCH_APP"] = "啟動應用";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_TITLE"] = "沒有玩家";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_MESSAGE"] = "請先添加一個玩家才能啟動應用。";

// CreatePlayerModal
translations["MSG_PARENT_PAGE_CREATE_PLAYER_TITLE"] = "添加玩家";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_ICON_TITLE"] = "選擇頭像";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_CONFIRM_TITLE"] = "確認";
translations["MSG_TOAST_CREATE_PLAYER_SUCCESS"] = "玩家添加成功";
translations["MSG_CREATE_USER_PREVIEW_MESSAGE_BY_PARENT"] = "使用此資訊註冊玩家";
translations["MSG_PRESET_ICON_TITLE_BY_PARENT"] = "選擇頭像";
translations["MSG_ICON_CATEGORY_ALL_BY_PARENT"] = "全部";
translations["MSG_UPLOAD_ICON_DRAG_DROP_BY_PARENT"] = "將圖片拖放到這裡";
translations["MSG_UPLOAD_ICON_CLICK_BY_PARENT"] = "或點擊選擇圖片";
translations["MSG_UPLOAD_ICON_REMOVE_BY_PARENT"] = "刪除";
translations["MSG_UPLOAD_ICON_TYPE_ERROR"] = "請選擇 JPG 或 PNG 格式的圖片";
translations["MSG_UPLOAD_ICON_SIZE_ERROR"] = "檔案大小必須在 5MB 以下";
translations["MSG_SELECT_PLACEHOLDER"] = "請選擇";
translations["MSG_COLOR_SELECT_SHADE_BY_PARENT"] = "選擇喜歡的色調";
translations["MSG_PROFILE_AI_APPEARANCE_BY_PARENT"] = "外觀";

// CreatePlayerModal - 額外金鑰（從主要 i18n 複製）
translations["MSG_CREATE_USER_TITLE_GENDER_BY_PARENT"] = "孩子的性別";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY_BY_PARENT"] = "孩子的生日";
translations["MSG_CREATE_USER_TITLE_PREVIEW_BY_PARENT"] = "確認註冊資訊";
translations["MSG_CREATE_USER_BTN_NEXT_BY_PARENT"] = "下一步";
translations["MSG_CREATE_USER_BTN_GENERATE_BY_PARENT"] = "生成頭像";
translations["MSG_CREATE_USER_STEP_NAME_BY_PARENT"] = "名字";
translations["MSG_CREATE_USER_STEP_ICON_BY_PARENT"] = "頭像";
translations["MSG_CREATE_USER_STEP_CONFIRM_BY_PARENT"] = "確認";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "姓名%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT_BY_PARENT"] = "請輸入孩子的名字";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_BY_PARENT"] = "喜歡的顏色";
translations["MSG_SUBJECT_LANGUAGE_BY_PARENT"] = "國語";
translations["MSG_SUBJECT_LIFE_BY_PARENT"] = "生活";
translations["MSG_SUBJECT_INTEGRATED_BY_PARENT"] = "綜合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES_BY_PARENT"] = "活動";

// CreatePlayerModal - 步驟標籤
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_NAME"] = "名字";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_LANGUAGE"] = "語言";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_ICON"] = "頭像";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_CONFIRM"] = "確認";
translations["MSG_CREATE_USER_TITLE_LANGUAGE_BY_PARENT"] = "請選擇孩子的顯示語言";
translations["MSG_USER_PROFILE_NAME_PLACEHOLDER_BY_PARENT"] = "孩子的名字";

// CreatePlayerModal - 子步驟標籤（6步）
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_APPEARANCE"] = "外貌";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_COLOR"] = "喜歡的顏色";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BEST_SUBJECT"] = "擅長的科目";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_ICON"] = "頭像";

// 素材刪除
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_BTN"] = "刪除";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_TITLE"] = "確定刪除此素材？";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_MESSAGE"] =
  "「%{name}」將被刪除。\n刪除後無法恢復。";

// 認證畫面
translations["MSG_SIGN_IN_WITH_MAIL"] = "使用電子郵件登入";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "沒有帳號？立即註冊";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "請輸入密碼";
translations["MSG_SIGN_LOGIN_FAILED"] = "電子郵件地址或密碼不正確。";
translations["MSG_SIGN_UP_BTN"] = "註冊";
translations["MSG_SIGN_UP_WITH_MAIL"] = "使用電子郵件註冊";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "已有帳號？立即登入";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "密碼不相符";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "此電子郵件已被註冊。請嘗試其他電子郵件地址。";
translations["MSG_SIGN_UP_FAILED"] = "帳號建立失敗。請重試。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "帳號註冊成功。";
translations["MSG_SIGN_UP_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_USER_MAIL"] = "電子郵件";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "確認密碼";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "請輸入電子郵件地址";
translations["MSG_SIGN_EMAIL_INVALID"] = "請輸入有效的電子郵件地址";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "重設密碼";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "返回登入";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "家長";

// 刪除帳戶模態框
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_PREFIX"] =
  "如果您希望刪除已註冊的帳戶，請點擊";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_CLICK_HERE"] = "這裡";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_SUFFIX"] = "。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_1"] = "現在不（定期）使用了";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_2"] = "內容不足";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_3"] = "應用程式難以操作";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_4"] = "啟動和遊玩速度太慢";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_5"] = "通知太煩人";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_6"] = "其他";
translations["MSG_NEXT_BTN"] = "下一步";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FEEDBACK_LABEL"] =
  "如有其他意見請告訴我們（可選）";

// 認證畫面 - 返回 Onboarding 按鈕
translations["MSG_AUTH_BACK_TO_START"] = "返回起始頁面";

// 方案比較表 - 玩家數
translations["MSG_PARENT_PAGE_USERS_FREE"] = "2人";
translations["MSG_PARENT_PAGE_USERS_STANDARD"] = "4人";
translations["MSG_PARENT_PAGE_USERS_PREMIUM"] = "8人";

// 恢復購買
translations["MSG_SUBSCRIPTION_RESTORE_BTN"] = "恢復購買";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_TITLE"] = "恢復完成";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_MESSAGE"] = "已恢復您的購買資訊";

// 家長資料 - 您的角色
translations["MSG_USER_ROLE_TITLE"] = "您";

// 配飾
translations["MSG_ACCESSORY_TITLE_BY_PARENT"] = "配飾";
translations["MSG_ACCESSORY_NONE_BY_PARENT"] = "無";
translations["MSG_ACCESSORY_MEGANE_BY_PARENT"] = "眼鏡";
translations["MSG_ACCESSORY_BOUSHI_BY_PARENT"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN_BY_PARENT"] = "髮夾";
translations["MSG_ACCESSORY_RIBBON_BY_PARENT"] = "蝴蝶結";
translations["MSG_ACCESSORY_BANDAID_BY_PARENT"] = "OK繃";
translations["MSG_PARENT_PAGE_EDIT_ACCESSORY"] = "編輯配飾";

// Parent Registration Promotion
translations["MSG_PARENT_REGISTRATION_TITLE"] = "家長註冊";
translations["MSG_PARENT_REGISTRATION_OVERLAY_HINT"] = "需要家長註冊";
translations["MSG_TRIAL_DATA_NOT_CLAIMED"] = "登入的帳號已達玩家上限，體驗中的玩家資訊未能繼承。";

translations["MSG_SUBSCRIPTION_REQUEST_CTA_TITLE"] = "您的孩子發來了購買請求";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BODY_WITH_PLAN"] = "%{name}希望購買「%{plan}」。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BODY_NO_PLAN"] = "%{name}希望購買付費方案。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BUY_BTN"] = "購買";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VIEW_PLANS_BTN"] = "查看方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_PLAN_STANDARD"] = "基本方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_PLAN_PREMIUM"] = "特別方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_REMAINING_DAYS"] = "此請求將在%{days}天後過期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_REMAINING_TODAY"] = "此請求將於今天過期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ALREADY_ACTIVE"] = "您已在使用付費方案。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ALREADY_ACTIVE_BTN"] = "使用中";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_EXPIRED"] = "此請求已過期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_EXPIRED_BTN"] = "已過期";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_SAFETY_NOTE"] =
  "點擊按鈕後會開啟確認頁面，不會立即扣款。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_PROJECTS"] = "作品數量";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE"] = "AI圖像";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_PROJECTS"] = "%{count}個";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_CHAT"] = "AI助手";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE_COUNT"] = "生成次數";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE_SIMULTANEOUS"] = "單次張數";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_STORAGE"] = "儲存空間";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_TIMES"] = "%{count}次";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_SHEETS"] = "%{count}張";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_UNLIMITED"] = "無限制";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_MONTHLY"] = "每月 %{price}";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ANNUAL"] = "每年 %{price}";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ANNUAL_DEAL"] = "省2個月";

export default translations;
